<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản Lý Vận Hành Trang Trại</div>
        
        <div class="col-lg-5 col-12 pr-0">
          <label class="p-col-fixed txt-left p-0 m-0">Trang trại</label>
          <div class="p-col p-0 pt-1">
            <Dropdown class="col-12 pr-2 pl-2" v-model="farm" :options="farmOptions" optionLabel="name" placeholder="Tất cả" :showClear="true"/>
          </div>
        </div>

        <BlockTotal :data.sync="total_report" :loading.sync="totalLoading" :decimal="3"/>

      </div>

      <div class="card card-w-title">

        <div style="font-weight: bolder; font-size: large;">THEO DÕI TÌNH HÌNH TRẠNG THÁI VÀ VẬN HÀNH CỦA CHỦNG LOẠI CUA</div>

        <div class="mt-2">
          <!-- {{listData}} -->
           <BaseDatatable
            :key="componentKey"
            :tableData="listData"
            :model="dataModel"
            :getFilterOptions="getFilterOptions"
            :whereKeyList="whereKeyList"
            @update-estimated-weight="updateEstimatedWeight"
            @update-imported-weight-and-crabs="updateImportedWeightAndCrabs"
            :farm="farm"
          ></BaseDatatable>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import BaseDatatable from './list'
import DataServices from '@/core/DataServices'
import BlockTotal from '@/components/blockTotal'

export default {
  components: {
    BaseDatatable,
    BlockTotal
  },

  data() {
    return {
      farm: null,
      farmOptions: [],
      total_report: [
        {
          label: 'Số unit hoạt động',
          value: 0
        },
        {
          label: 'Số hộp hoạt động',
          value: 0
        },
        {
          label: 'Số cua hiện tại',
          value: 0
        },
        // {
        //   label:'Trọng lượng nhập (kg)',
        //   value: 0
        // },
        {
          label: 'Tổng trọng lượng ước tính (kg)',
          value: 0
        },
      ],
      
      totalLoading: false,
      filters: {},
      filterOptions: {},
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      whereKeyList:{
        where_key: {
          deleted_at: {_is_null: true}
        }
      },
      numBox:0,
      numBoxActive: 0,
      numUnit: 0,
      numUnitActive: 0,
      page_transaction:null,
      dateReport: null,
    }
  },

  mounted () {
    this.initParams();
  },

  async created() {
    await this.getListFarm();
    this.modelName = this.$route.meta.model;
    if (this.modelName) {
      this.dataModel = DataServices.getModel(this.modelName);
    } else {
      console.error("Model name is not defined in route meta.");
    }
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    this.getData();
  },

  watch: {
    '$route': 'initParams',
    "farm"() {
      if (this.farm?.id) {
        this.$set(this.filters, 'farm_id', {value: this.farm?.id, type_input: 'select'});
        if (!this.totalLoading) {
          this.getData();
          if (this.total_report[0].label === "Số trang trại") {
            this.total_report.shift();
          }
        }
      } else {
        this.$delete(this.filters, 'farm_id');
        if (!this.totalLoading) {
          this.getData();
        }
      }
      this.componentKey++;
      return;
    }
  },
  methods: {
    async getData() {
      // this.lazyParams.filters = this.filtersCustom;
      this.totalLoading = true;
      
      var filter = {};
      if (this.filters) {
        for (const [key, value] of Object.entries(this.filters)) {
          filter[key] = value.value;
        }
      }

      // Get "Số trang trại"
      if (!this.farm) {
        await this.countFarm();
      }

      // Get "Số unit hoạt động"
      await this.getUnitCounts();
      const unitReportItem = this.total_report.find(r => r.label === "Số unit hoạt động");
      if (unitReportItem) {
        unitReportItem.value = `${this.numUnitActive}/${this.numUnit}`;
      }

      // Get "Số hộp hoạt động"
      await this.getObjectBoxCounts();
      const boxReportItem = this.total_report.find(r => r.label === "Số hộp hoạt động");
      if (boxReportItem) {
        boxReportItem.value = `${this.numBoxActive}/${this.numBox}`;
      }

      this.totalLoading = false;
    },

    async countFarm() {
      try {
        await this.getListFarm();
        var count = this.farmOptions.length;
        this.total_report.unshift({
          label: 'Số trang trại',
          value: count
        });
      } catch (error) {
        console.error("Error in countFarm:", error);
      }
    },

    async getObjectBoxCounts() {
      try {
        const gqLQueryListCsUnits = DataServices.getList("cs_unit", { fields: "id" });
        const whereCsUnit = {
          ...(this.farm?.id && { farm_id: { _eq: this.farm.id } })
        };

        const resCsUnits = await this.$apollo.mutate({
          mutation: gqLQueryListCsUnits,
          variables: {
            where_key: whereCsUnit,
            orderBy: { created_at: "desc" }
          }
        });

        const csUnitList = resCsUnits.data["cs_unit"];
        const csUnitIds = csUnitList.map(unit => unit.id);

        this.numUnit = csUnitIds.length;

        if (csUnitIds.length === 0) {
          this.numBox = 0;
          this.numBoxActive = 0;
          return;
        }

        const gqLQueryListUnits = DataServices.getList("unit", { fields: "id" });
        const whereUnit = {
          unit_id: { _in: csUnitIds }
        };

        const resUnits = await this.$apollo.mutate({
          mutation: gqLQueryListUnits,
          variables: {
            where_key: whereUnit,
            orderBy: { created_at: "desc" }
          }
        });

        const unitList = resUnits.data["unit"];
        const unitIds = unitList.map(unit => unit.id);

        if (unitIds.length === 0) {
          this.numBox = 0;
          this.numBoxActive = 0;
          return;
        }

        const gqLQueryListBoxes = DataServices.getList("obj_box", { fields: "id, total" });
        const whereBoxes = {
          unit_id: { _in: unitIds }
        };

        const resBoxes = await this.$apollo.mutate({
          mutation: gqLQueryListBoxes,
          variables: {
            where_key: whereBoxes,
            orderBy: { created_at: "desc" }
          }
        });

        const boxList = resBoxes.data["obj_box"] || [];
        this.numBox = boxList.length;
        this.numBoxActive = boxList.filter(box => box.total > 0).length;

      } catch (error) {
        console.error("Error in getObjectBoxCounts:", error);
      }
    },

    async getUnitCounts() {
      try {
        const gqLQueryListCsUnits = DataServices.getList("cs_unit", { fields: "id" });
        const whereCsUnit = {
          ...(this.farm?.id && { farm_id: { _eq: this.farm.id } })
        };

        const resCsUnits = await this.$apollo.mutate({
          mutation: gqLQueryListCsUnits,
          variables: {
            where_key: whereCsUnit,
            orderBy: { created_at: "desc" }
          }
        });

        const csUnitList = resCsUnits.data["cs_unit"];
        const csUnitIds = csUnitList.map(unit => unit.id);

        this.numUnit = csUnitIds.length;

        if (csUnitIds.length === 0) {
          this.numUnitActive = 0;
          return;
        }

        const gqLQueryListUnits = DataServices.getList("unit", { fields: "unit_id, active" });
        const whereUnitsActive = {
          unit_id: { _in: csUnitIds },
          active: { _eq: true }
        };

        const resUnits = await this.$apollo.mutate({
          mutation: gqLQueryListUnits,
          variables: {
            where_key: whereUnitsActive,
            orderBy: { created_at: "desc" }
          }
        });

        const activeUnits = resUnits.data["unit"];
        const activeCsUnitIds = new Set(activeUnits.map(unit => unit.unit_id).filter(Boolean));
        this.numUnitActive = activeCsUnitIds.size;

      } catch (error) {
        console.error("Error in getUnitCounts:", error);
      }
    },

    async getListFarm() {
      var gqLQueryList = DataServices.getList("farm", {"fields": "id, name"});
      var where = {
          active: {_eq: true}
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { created_at: "desc" },
        },
      });
      var listData = resData.data["farm"];
      this.farmOptions = listData;
    },

    initParams() {
      this.$store.commit('setLoading', true);
      this.$set(this, 'dateReport', [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()]);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
    },

    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = []
      if (field.type == 'Selection' || field?.options) {
        result = field.options;
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      return result;
    },

    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },

    updateEstimatedWeight(totalEstimatedWeight) {
      const estimateWeightReportItem = this.total_report.find(r => r.label === "Tổng trọng lượng ước tính (kg)");
      if (estimateWeightReportItem) {
        if (totalEstimatedWeight === 0) {
          estimateWeightReportItem.value = 0;
        } else {
          estimateWeightReportItem.value = totalEstimatedWeight.toFixed(3);
        }
      }
    },

    updateImportedWeightAndCrabs({ totalCrabs }) {
      // Khi nào cần tính trọng lượng nhập thì sẽ import totalImportedWeight cùng totalCrabs
      // const importedWeightReportItem = this.total_report.find(r => r.label === "Trọng lượng nhập (kg)");
      // if (importedWeightReportItem) {
      //   if (totalImportedWeight === 0) {
      //     importedWeightReportItem.value = 0;
      //   } else {
      //     importedWeightReportItem.value = totalImportedWeight.toFixed(3);
      //   }
      // }
      const crabsReportItem = this.total_report.find(r => r.label === "Số cua hiện tại");
      if (crabsReportItem) {
        crabsReportItem.value = totalCrabs;
      }
    },
  }
}
</script>

<style lang="css">

label{
  font-weight: bold;
}
</style>